export default __webpack_public_path__ + "static/media/cameraworld2.2057a6f7.PNG";